import { config } from "@/lib/config";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import type { ComponentProps } from "react";
import Text from "../text/text";

const edgeDigitalUrl = "https://edge-digital.com";

export default function Branding({
  className,
  ...props
}: ComponentProps<typeof Text>) {
  const { t } = useTranslation();
  return (
    <Text
      as="div"
      size="sm"
      className={cn(
        "pointer-events-none flex items-center justify-center gap-1 text-[0.6875rem] text-foreground-pressed",
        className,
      )}
      {...props}
    >
      {t("branding_developed_by")}{" "}
      <a
        href={edgeDigitalUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-foreground pointer-events-auto underline decoration-dotted underline-offset-4"
      >
        Edge Digital
      </a>
      <span>·</span>
      <span>v{config.version}</span>
    </Text>
  );
}
